type TicketLocation = { search: string; state: unknown };

/** 优先返回实际进入的列表；宿主直接打开详情时才使用上下文页作为兜底。 */
export function embeddedTicketReturnTo({ search, state }: TicketLocation, hasBusinessContext: boolean): string {
  const returnTo = state && typeof state === "object" && "returnTo" in state ? state.returnTo : undefined;
  if (typeof returnTo === "string" && ["/embedded/tickets", "/embedded/context"].includes(returnTo.split("?")[0] ?? "")) {
    return returnTo;
  }
  return search ? `/embedded/tickets${search}` : hasBusinessContext ? "/embedded/context" : "/embedded/tickets";
}
